// src/components/demo/DemoWaiverPublic.js
//
// Public, unauthenticated waiver page at /waiver (Nigel 2026-07-22).
// Carbon-masthead treatment from Claude Design round 2 (DWaiverPublic):
// dark masthead + version tag, paper body, sand footer with hello@ contact.
// Read-only rendering of the EXACT text riders sign (src/config/demoWaiver.js
// stays the single client-side source of truth) — linkable from the
// waiver-copy email, waka.surf, and printed signage at the rack.

import React from 'react';
import { FWordmark, FLabel } from '../foam/FoamPrimitives';
import { WAIVER_VERSION, WAIVER_SECTIONS } from '../../config/demoWaiver';

const display = '"Saira Condensed", "Arial Narrow", Arial, sans-serif';

export default function DemoWaiverPublic() {
  return (
    <div
      className="w-full mx-auto max-w-[560px]"
      style={{
        minHeight: '100dvh', background: 'var(--foam-paper)', color: 'var(--foam-ink)',
        fontFamily: '"Archivo", -apple-system, system-ui, sans-serif',
        display: 'flex', flexDirection: 'column',
      }}
    >
      {/* carbon masthead */}
      <div style={{ background: 'var(--foam-carbon)', color: 'var(--foam-paper)', padding: '30px 26px 26px' }}>
        <div className="flex justify-between items-center">
          <FWordmark dark />
          <FLabel color="var(--foam-mute)">Read-only</FLabel>
        </div>
        <div style={{ fontFamily: display, fontWeight: 800, fontSize: 44, lineHeight: 0.92,
          letterSpacing: '-0.01em', textTransform: 'uppercase', marginTop: 22 }}>
          Liability<br />waiver
        </div>
        <div className="font-mono uppercase" style={{ fontSize: 11, letterSpacing: '0.1em',
          color: 'var(--foam-orange)', marginTop: 14 }}>
          Version {WAIVER_VERSION}
        </div>
        <p style={{ fontSize: 13.5, color: '#C4C1B5', lineHeight: 1.55, margin: '12px 0 0' }}>
          The full text every WAKA demo rider agrees to before going out. This is the public
          reference copy — you sign it on the day, on the staff device at the rack.
        </p>
      </div>

      {/* body */}
      <div style={{ padding: '4px 26px 28px', flex: 1 }}>
        {WAIVER_SECTIONS.map((s) => (
          <div key={s.heading}>
            <div style={{ fontFamily: display, fontWeight: 800, fontSize: 22, textTransform: 'uppercase',
              letterSpacing: '-0.01em', margin: '26px 0 10px', lineHeight: 1 }}>
              {s.heading}
            </div>
            <div className="font-sans" style={{ fontSize: 14, lineHeight: 1.65,
              color: 'var(--foam-ink-2)', whiteSpace: 'pre-line' }}>
              {s.body}
            </div>
          </div>
        ))}
        <div className="font-mono" style={{ marginTop: 26, padding: 16, background: 'var(--foam-paper-2)',
          fontSize: 10.5, lineHeight: 1.6, color: 'var(--foam-mute)', letterSpacing: '0.03em' }}>
          {WAIVER_VERSION} · The signed version is timestamped and hashed at submission.
        </div>
      </div>

      {/* footer */}
      <div style={{ background: 'var(--foam-paper-2)', borderTop: '1.5px solid var(--foam-line)',
        padding: '22px 26px 28px' }}>
        <FWordmark size={14} />
        <div style={{ fontSize: 12.5, color: 'var(--foam-ink-2)', lineHeight: 1.6, marginTop: 12 }}>
          Questions about this waiver?{' '}
          <a href="mailto:hello@waka.surf"
            style={{ color: 'var(--foam-orange)', fontWeight: 700, textDecoration: 'none' }}>
            hello@waka.surf
          </a>
        </div>
        <div className="font-mono" style={{ fontSize: 10, color: 'var(--foam-mute)',
          letterSpacing: '0.06em', marginTop: 10 }}>
          demo.waka.surf/waiver · WAKA Inc · Snowmass Village, CO
        </div>
      </div>
    </div>
  );
}
